'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var React = require('react');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children", "className"];
var BadgeIcon = function BadgeIcon(props) {
  var children = props.children,
    className = props.className,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var _children = /*#__PURE__*/React__default["default"].isValidElement(children) ? /*#__PURE__*/React__default["default"].cloneElement(children, {
    'aria-hidden': true,
    focusable: false
  }) : children;
  var _className = utils.cx('chakra-badge__icon', className);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.span, _extends__default["default"]({
    display: "inline-flex",
    alignSelf: "center",
    flexShrink: 0
  }, rest, {
    className: _className
  }), _children);
};
exports.BadgeIcon = BadgeIcon;